import { DashboardNavigation as Navigation } from "@replicate/ui";
import type { AccountWithAvatar } from "../types";

export default function DashboardNavigation({
  account,
  activePath,
}: { account: AccountWithAvatar; activePath: string }) {
  const kind =
    account.kind !== "anonymous"
      ? (account.kind as "user" | "organization")
      : undefined;
  const username = account.kind !== "anonymous" ? account.username : undefined;

  return (
    <Navigation
      currentPath={activePath}
      onSelectChange={(href) => {
        window.location.href = href;
      }}
      kind={kind}
      username={username}
    />
  );
}
